import { updatesData } from '@/mocks/home';

export default function UpdatesSection() {
  const getTagStyle = (tag: string) => {
    switch (tag) {
      case '上新': return 'bg-primary-100 text-primary-700';
      case '更新': return 'bg-accent-100 text-accent-700';
      case '热播': return 'bg-red-100 text-red-600';
      case '专题': return 'bg-secondary-100 text-secondary-700';
      case '公告': return 'bg-background-200 text-foreground-600';
      case '热门': return 'bg-orange-100 text-orange-600';
      default: return 'bg-background-200 text-foreground-600';
    }
  };

  return (
    <section id="updates" className="py-16 md:py-24 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
            最新动态
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            春色影视每日更新，不错过任何精彩
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          {updatesData.map((item, idx) => (
            <div key={idx} className="flex gap-4 pb-6 relative">
              {idx < updatesData.length - 1 && (
                <div className="absolute left-[19px] top-10 bottom-0 w-px bg-background-300/60"></div>
              )}
              <div className="w-[38px] h-[38px] flex items-center justify-center rounded-full bg-background-200 flex-shrink-0 mt-0.5">
                <div className="w-2.5 h-2.5 rounded-full bg-primary-500"></div>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex flex-wrap items-center gap-2 mb-1.5">
                  <span className="text-foreground-400 text-xs">{item.time}</span>
                  <span className={`px-2 py-0.5 rounded text-xs font-medium whitespace-nowrap ${getTagStyle(item.tag)}`}>
                    {item.tag}
                  </span>
                </div>
                <p className="text-foreground-700 text-sm md:text-base leading-relaxed">{item.content}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}